import React, { useCallback } from 'react';
import { MenuItem, Tooltip } from '@mui/material';
import { MenuOptionsProps } from './types';

const MenuOption = (props: MenuOptionsProps) => {
  const { mainAction, tabBarId, option, optionIndex, onClick, classes } = props;

  const onClickHandler = useCallback(() => {
    if (!option.disabled) {
      onClick(option);
    }
  }, [onClick, option]);

  const menuItem = (
    <MenuItem
      id={`${mainAction?.id ?? tabBarId}-action-item-${optionIndex + 1}`}
      onClick={onClickHandler}
      className={option.disabled ? classes?.disabled : ''}>
      {option.label}
    </MenuItem>
  );

  if (option.tooltip) {
    return (
      <Tooltip title={option.tooltip} placement="left" arrow>
        <span>{menuItem}</span>
      </Tooltip>
    );
  }

  return menuItem;
};

export default MenuOption;
